var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-material-upload-area",class:_vm.size},[_vm._m(0),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon"},[_c('span',{staticClass:"el-icon-video-camera"})])
}]

export { render, staticRenderFns }